import React, { useRef, useState,useEffect } from "react";
import html2canvas from "html2canvas";
import './homes.css'
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import {Button,Modal,ModalHeader} from 'reactstrap'
import { useNavigate } from 'react-router-dom';
import Axios from 'axios'
import { jsPDF } from "jspdf";
import Table from 'react-bootstrap/Table';
import { QRCodeCanvas } from "qrcode.react";
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';

export default function Register() {
    const [providers, setProviders] = useState([]);
    const [selectedProvider, setSelectedprovider] = useState('')
    const [categories, setCategories] = useState([])
    const [selectedCategory, setSelectedcategory] = useState('')
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedproduct] = useState('');
    const [amount, setAmount] = useState('');
    const [businessName, setBusinessname] = useState('')
    const [email, setEmail]= useState('')
    const [phone, setPhone] = useState('')
    const [submitText, setSubmittext] = useState('PAY NOW')
    const navigate = useNavigate();
    const [tariff, setTariff] = useState('');
    const [rate, setRate] = useState('');
    const [tab, setTab] = useState(1);
    const [isPaid, setIspaid] = useState(false);
    const [confirmText, setConfirmtext] = useState('Confirm payment')
    const [subscriptions, setSubscriptions] = useState([])
    const [invoiceNo, setInvoiceNo] = useState('')
    const [modal,setModal] = useState(false)

    const toggle =()=>{
        setModal(!modal)
    }
    

   
    const pdfRef = useRef();
    const [pdfUrl, setPdfUrl] = useState("https://example.com/mydocument.pdf"); // Change to your actual document URL
  
    const generatePDF = () => {
        const input = pdfRef.current;
      
        html2canvas(input).then((canvas) => {
          const imgData = canvas.toDataURL("image/png"); // Convert HTML to image
          const pdf = new jsPDF("p", "mm", "a5");
          const imgWidth = 150;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      
          const qrCanvas = document.getElementById("qrCode");
          if (qrCanvas) {
            const qrImg = qrCanvas.toDataURL("image/png"); // Convert QR to image
            // pdf.addImage(qrImg, "PNG", 75, imgHeight + 10, 50, 50); // Position QR code
          } else {
            console.error("QR code not found.");
          }
      
          // Save and Open PDF
          pdf.save("document_with_qr.pdf");
          const pdfBlob = pdf.output("blob");
          const pdfBlobUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfBlobUrl, "_blank");
        });
      };

    const getTab1 =()=>{
        setTab(1)
    }

    const getTab2 =()=>{
        if(businessName !== '' && email !== '' && phone !== '' && selectedCategory !== '' && selectedProduct !== '') {
            setTab(2)
        }
        else{
            toast.error('Please fill the fields and select a tariff & rate!')
        }

    }
    


    useEffect(()=>{
        const fetchProviders =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3073/api/getProviders')
            const data = await res.json();
            setProviders(data)
        }
        const fetchSubscriptions =async()=>{
            const res = await fetch('https://panel.yunshuglobal.com:3073/api/getSubscriptions')
            const data = await res.json();
            setSubscriptions(data)
            setInvoiceNo(`INV-00${data.length+1}`)
        }

        fetchProviders()
        fetchSubscriptions()

        
    },[])

    useEffect(()=>{
        const fetchProviders =async()=>{

            const res = await fetch(`https://panel.yunshuglobal.com:3073/api/getCategories`)
            const data = await res.json();
            setCategories(data)
        }

        
            fetchProviders()
        

       
    },[])

    useEffect(()=>{
        const fetchCategories =async()=>{

            const res = await fetch(`https://panel.yunshuglobal.com:3073/api/getProducts?selectedCategory=${selectedCategory}`)
            const data = await res.json();
            setProducts(data)
        }

        if(selectedCategory){
            fetchCategories()
        }

       
    },[selectedCategory])

    useEffect(()=>{
        const getProduct =async()=>{
            const res = await fetch(`https://panel.yunshuglobal.com:3073/api/getSelectedProduct?selectedProduct=${selectedProduct}`);
            const data = await res.json();
            setAmount(data.Amount);
            setTariff(data.Category);
            setRate(data.Product)
        }

        if(selectedProduct){
            getProduct()
        }
    },[selectedProduct])

    const paynow =async()=>{
        setSubmittext('Waiting for response...')
        
        const newPhone = '254'+phone.slice(1)
        const res = await Axios.post('https://workflows.uuidesign.xyz/webhook/bdacf3d0-7f12-457a-a48e-97779a41d5a8',{phone:newPhone,amount,businessName});
        toast.success('Prompt set to your phone')
     
        setTimeout(() => {
            confirmPayment();
          }, 60000);


    }

    const confirmPayment =async()=>{
        const newPhone = '254'+phone.slice(1)

        const res = await fetch(`https://panel.yunshuglobal.com:3073/api/confirmPayment?phone=${newPhone}&amount=${amount}`);
        const data = await res.json();
        const {success} = data;
        if(success){
           
            const res2 = await fetch('https://panel.yunshuglobal.com:3073/api/createCustomer',{
                method:"POST",
                headers:{
                    "Content-Type":"application/json"
                },
                body:JSON.stringify({selectedProvider,businessName,email,phone,tariff,rate,amount}),
                credentials:"include"
            })
            setConfirmtext('Confirm payment');
            const data2 = await res2.json();
            setTab(3)
            setSubmittext('PAID')
            toast.success('Payment successful')
        }
        else{
            setTab(3)
            setSubmittext('PAY NOW')
            toast.error('Payment not received!')
        }
    }



    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const today2 = new Date().toLocaleDateString();
  return (
    <div>

    <ToastContainer />
        <div className="registerContainer">

           
            <div className="leftContainer">
            <div className="container">
                <img src="sautilogo.png" className='registerLogo' alt="" />
                <h2>Music Users Licensing Portal</h2>
                <h5 style={{textAlign:'center',marginBottom:'5%'}}>Powered by MUSTECH NETWORK LTD</h5>
               {tab == 1 &&
               <>
               <div className="inputEntries">
                
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Business name/Vehicle Reg. No" onChange={(e)=>{setBusinessname(e.target.value)}} >
                        <Form.Control  className='inputSearch'   type="text" placeholder="Business name/Vehicle Reg. No" value={businessName} />
                    </FloatingLabel>
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Email" onChange={(e)=>{setEmail(e.target.value)}} >
                        <Form.Control  className='inputSearch'   type="email" placeholder="Email" value={email} />
                    </FloatingLabel>
                    <FloatingLabel className='formInput' controlId="floatingInputGrid" label="Phone" onChange={(e)=>{setPhone(e.target.value)}} >
                        <Form.Control  className='inputSearch'   type="text" placeholder="Phone" value={phone} />
                    </FloatingLabel>
                    <FloatingLabel className='formInput' controlId="floatingSelectGrid" label="Select tariff" onChange={(e)=>{setSelectedcategory(e.target.value)}}>
                    <Form.Select className='inputSearch'>
                        <option selected disabled>Select tariff</option>
                        {categories.map((val)=>{
                            return(
                                <option value={val.Categorycode}>{val.Categorycode}-{val.Category}</option>
                            )
                            
                        })}
           
                    </Form.Select>
                    </FloatingLabel>
                    <FloatingLabel className='formInput' controlId="floatingSelectGrid" label="Select rate" onChange={(e)=>{setSelectedproduct(e.target.value)}}>
                    <Form.Select className='inputSearch'>
                        <option selected disabled>Select rate</option>
                        {products.map((val)=>{
                            return(
                                <option value={val.id}>{val.Product} - Kes.{val.Amount}</option>
                            )
                            
                        })}
           
                    </Form.Select>
                    </FloatingLabel>


                    <Button color='success' className='btnSubmit' onClick={getTab2}>Generate invoice</Button>
                   
                    
                </div>

               </>
               
               }

               {tab == 2 &&
               <div className='tab2'>
                <h4 style={{color:'#9e2308'}}>Music Users License Platform</h4>
                <h6 style={{color:'#9e2308'}}>Invoice</h6>
                <div className="invoiceTop">
                    <div className="billDetails">
                    <h5>Bill to:</h5>
                    <p ><strong>{businessName}</strong></p>
                    <p><strong>{email}</strong></p>
                    <p><strong>{phone}</strong></p>


                    </div>
                    <div className="invoiceDetails"     >
                    <p ><strong>Invoice No: {invoiceNo}</strong></p>
                    <p ><strong>Date: {formattedDate}</strong></p>
                    <p><strong>Due: Kes. {amount}</strong></p>
                    </div>

                </div>
                <Table striped bordered hover id="dataTable">


            <thead>
                <tr>
                    
                    <th scope="col">#</th>
                    <th scope="col">Description</th> 
                    <th scope="col">Rate</th>
                    <th scope="col">Amount</th>


                </tr>
            </thead>
            <tbody>
           
                    <tr>
                        <td>1</td>
                        <td>{selectedCategory}. {tariff}</td>
                        <td>{rate}</td>
                        <td>Kes.{amount}/=</td>
                       
                        
                    </tr>

            </tbody>
            </Table>
               
                

               
                <div className="">
                    
                    <Button color='success' onClick={paynow}>{submitText}</Button>
                    
                </div>
                
               </div>
               
               }
               {tab == 3 &&
               <div className="tab2">
                <h2 className='success'>PAYMENT IS SUCCESSFUL</h2>
                <Button className='downloadButton' color='success' onClick={toggle}>Download license</Button>
               </div>
               
               }


            </div>
                

            </div>

          
            
        </div>


    <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader>Download license</ModalHeader>
        <div className="modalContainer" style={{padding:'20px'}}>
        <div >
             <div style={{ textAlign: "center", width:'100%' }}>
                  
                  
                  {/* Content to Export */}
                  <div ref={pdfRef} style={{ padding: 20, background: "white"}}>
                  <div className="licenseBody" style={{border:'1px solid black',marginLeft:'1%',marginRight:'2%'}}>
                    <img src="/sautilogo.png" alt="" className="licenseLogo" />
                    <h2 className="licenseTitle">MUSIC LICENSE</h2>
                    
                    <div className="licenseContent" style={{marginLeft:'2%',marginRight:'2%'}}>
                    <div className="" style={{display:'flex',justifyContent:'space-between'}}>
                        <div className="">
                        <p >License No: 1234</p>
                        <p >Date: {today2}</p>
            
                        </div>
                        <div className="">
                               
            
                        </div>
                    </div>
            
                    <div className="licenseTable" style={{display:'flex',justifyContent:'space-between'}}>
                        <div className="licenseLeft" style={{flex:6}}>
                            <h6 style={{textAlign:'left'}}>THE LICENCEE</h6>
                            <div className="table" style={{border:'2px solid black',padding:'10px'}}>
                                <p>Name: <span style={{textDecoration:'underline'}}>{businessName}</span></p>
                                <hr />
                                <p>Phone: <span style={{textDecoration:'underline'}}>{phone}</span></p>
                            </div>
              
                        </div>
                        <div className="licenseRight" style={{flex:6}}>
                        <h6 style={{textAlign:'left'}}>THE TARIFF</h6>
                            <div className="table" style={{border:'2px solid black',padding:'10px'}}>
                                <p>Tariff: <span style={{textDecoration:'underline'}}>{tariff}</span></p>
                                <hr />
                                <p>Amount paid: <span style={{textDecoration:'underline'}}>Kes.{amount} /=</span></p>
                            </div>
            
                        </div>
                    </div>
                    <p>This license is issued by MUSTECH NETWORK LTD and grants the licensee the right to use the specified music under the terms outlined in the selected tariff. This license is valid only upon full payment and is non-transferable. Unauthorized use, reproduction, or distribution of the licensed music is strictly prohibited. For inquiries or further information, please contact SAYANEM. Thank you for supporting the rights of music creators.</p>
                    <div className="footer" style={{display:'flex', justifyContent:'space-between'}}>
                        <div className="">
                        <img src="esign.png" width='150px' alt="" />
                        <p>SIGN</p>
            
                        </div>
                        <div className="">
                            <QRCodeCanvas id="qrCode" value={pdfUrl} size={100} />
                            <p style={{textAlign:'center'}}>Scan me</p>
            
                        </div>
                    </div>
                    
                    
                    </div>
                    
                  </div>
            
                  {/* QR Code */}
            
            
                  {/* Button to Generate PDF */}
                  <br />
                  <Button color="success" onClick={generatePDF}>Download</Button>
                  {/* <button onClick={generatePDF}>Generate PDF with QR</button> */}
                  </div>
                </div>
        </div>
        </div>
    </Modal>

    </div>
  )
}
